import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { IProductsRecipe } from 'src/app/interfaces/product-recipe.interface';

@Component({
  selector: 'app-recipe',
  templateUrl: './recipe.component.html',
  styleUrls: ['./recipe.component.scss']
})
export class RecipeComponent implements OnInit {
  @Input() products: IProductsRecipe;
  @Output() showProduct = new EventEmitter;
  
  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 20);
  }

  showDetail(id: number){
    this.router.navigate(['/receta-detalle/',id]);
    if (this.router.url.includes('/receta-detalle')) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 20);
      this.showProduct.emit(id)
    }
  }

}
